import { render, staticRenderFns } from "./tabTable.vue?vue&type=template&id=fdd5fc7a&scoped=true"
import script from "./tabTable.vue?vue&type=script&lang=js"
export * from "./tabTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd5fc7a",
  null
  
)

export default component.exports